export enum TimeZoneLocation {
  PACIFIC = 'America/Los_Angeles',
  MOUNTAIN = 'America/Phoenix',
  CENTRAL = 'America/Chicago',
  EASTERN = 'America/New_York'
}
